import React, { useEffect } from "react";
import SplashScreen from "./SplashScreen";
import api from "../../store/api/api";
import { useDispatch } from "react-redux";
import { setCampaignList, setMemberships } from "../../store/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser, useAuthStatus, pathWithMfaGate } from "../../allauth/auth";

export default function Startup() {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const me = useUser();
    const [auth] = useAuthStatus();

    useEffect(() => {
        if (!me) return;
        api.get("myaccount/").then((res) => {
            console.log('pass to redux', res.data)
            const { memberships, ...account } = res.data;
            const campaigns = [];
            const seenCampaignIds = new Set();
            memberships.forEach(membership => {
                if (!seenCampaignIds.has(membership.campaign.id)) {
                    seenCampaignIds.add(membership.campaign.id);
                    campaigns.push(membership.campaign);
                }
            });
            dispatch(setCampaignList(campaigns));
            dispatch(setMemberships(memberships, account));
            if (location.pathname === '/startup') {
                const target = pathWithMfaGate(account.profile ?? {}, auth, '/select-campaign');
                navigate(target);
            }
        })
    }, [me, location.pathname, auth]);

    return <SplashScreen />
}
